import { createContext, useContext } from 'react';
import type { ServicePackage, RevisionFormState } from './types';

export type ServicePackageContextValue = {
  packages: ServicePackage[];
  loading: boolean;
  handleSave: (
    pkgId: string,
    term: number,
    data: RevisionFormState,
  ) => Promise<void>;
  handleCopyToTerm: (
    sourceRevisionId: string,
    targetTerm: number,
  ) => Promise<void>;
  /** Opens the copy-to-currency dialog for the given package id */
  requestClone: (pkgId: string) => void;
};

export const ServicePackageContext = createContext<ServicePackageContextValue>(
  null!,
);

export const useServicePackages = () => useContext(ServicePackageContext);
